import { IconProps } from '@components/Icons/index';

const defaultSize = 30;

export const RestartIcon = ({ size, className }: IconProps) => {
  return (
    <svg
      className={className}
      width={size || defaultSize}
      height={size || defaultSize}
      viewBox="0 0 28 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.00008 18.1416C4.00008 15.3916 5.11675 12.8916 6.93341 11.0749L4.56675 8.70827C2.16675 11.1249 0.666748 14.4583 0.666748 18.1416C0.666748 24.9416 5.75008 30.5416 12.3334 31.3583V27.9916C7.61675 27.1916 4.00008 23.0916 4.00008 18.1416ZM27.3334 18.1416C27.3334 10.7749 21.3667 4.80827 14.0001 4.80827C13.9001 4.80827 13.8001 4.82493 13.7001 4.82493L15.5167 3.00827L13.1667 0.641602L7.33341 6.47493L13.1667 12.3083L15.5167 9.95827L13.7167 8.15827C13.8167 8.15827 13.9167 8.1416 14.0001 8.1416C19.5167 8.1416 24.0001 12.6249 24.0001 18.1416C24.0001 23.0916 20.3834 27.1916 15.6667 27.9916V31.3583C22.2501 30.5416 27.3334 24.9416 27.3334 18.1416Z"
        fill="#2B60DE"
      />
    </svg>
  );
};
